(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-private-list-popup]');
    if (!popup) return;
    const key = 'private-list-hidden-until';
    const week = 7 * 24 * 60 * 60 * 1000;
    const setHidden = () => localStorage.setItem(key, String(Date.now() + week));
    const isHidden = () => Number(localStorage.getItem(key) || 0) > Date.now();
    const show = () => { if (!isHidden()) popup.hidden = false; };
    const success = popup.querySelector('.private-list__success');
    if (popup.dataset.privateListSubscribed === 'true') { setHidden(); return; }
    if (success) { popup.hidden = false; setHidden(); return; }
    window.setTimeout(show, 30000);
    document.addEventListener('mouseout', (event) => { if (event.clientY <= 0) show(); });
    popup.querySelector('[data-private-list-close]')?.addEventListener('click', () => { setHidden(); popup.hidden = true; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
